import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-black py-10 font-mono" }
const _hoisted_2 = {
  key: 0,
  class: "bg-black grid grid-flow-row auto-rows-max w-96 mx-auto inset-x-0 border-2 border-gray-800 z-20 fixed"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bg-red-600 text-white text-center" }, "+++ BITTE ANPASSEN UND BESTÄTIGEN +++", -1)
const _hoisted_4 = { class: "p-5 text-white" }
const _hoisted_5 = { class: "text-gray-400 text-xs" }
const _hoisted_6 = { class: "text-white text-2xl" }
const _hoisted_7 = { class: "w-full flex" }
const _hoisted_8 = { class: "grid grid-cols-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "justify-self-center" }, "Vorhanden", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "justify-self-center" }, "Präferiert", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "SMS", -1)
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "WhatsApp", -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Signal", -1)
const _hoisted_17 = ["disabled"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Threema", -1)
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "w-full flex" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "basicDiet",
  class: "mr-2 flex-none"
}, "Ernährung: ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", { value: "Undefined" }, "Undefiniert", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "Omnivorous" }, "Omnivor", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("option", { value: "Vegetarian" }, "Vegetarisch", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", { value: "Vegan" }, "Vegan", -1)
const _hoisted_26 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { class: "w-full flex" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  for: "restrictions",
  class: "mr-2 flex-none"
}, "Einschränkungen: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("option", { value: "None" }, "Keine", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "Kosher" }, "Kosher", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "Halal" }, "Halal", -1)
const _hoisted_32 = [
  _hoisted_29,
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "w-full flex" }
const _hoisted_34 = { class: "w-full flex" }
const _hoisted_35 = { class: "w-full flex" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "accomodation",
  class: "flex-grow"
}, "Ich hätte gerne Hotelinformationen", -1)
const _hoisted_37 = ["title", "confirmButton"]
const _hoisted_38 = {
  key: 1,
  class: "bg-black grid grid-flow-row auto-rows-max w-72 mx-auto inset-x-0 border-2 border-gray-800 z-20 fixed p-5"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "Möchten Sie diese Einträge bestätigen?", -1)
const _hoisted_40 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full min-w-screen absolute z-10 top-0 bg-black fixed bg-opacity-70" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_l_geo_json = _resolveComponent("l-geo-json")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_map = _resolveComponent("l-map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dialogVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.person.id) + " (" + _toDisplayString(_ctx.person.login) + ") ", 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.person.firstName) + " " + _toDisplayString(_ctx.person.lastName), 1),
            _withDirectives(_createElementVNode("input", {
              placeholder: "Straße",
              class: "bg-gray-800 w-full focus:bg-gray-700 focus:outline-none",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.person.contact.address.street) = $event)),
              required: "",
              autofocus: ""
            }, null, 512), [
              [_vModelText, _ctx.person.contact.address.street]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "00000",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.person.contact.address.zip) = $event)),
                class: "w-12 bg-gray-800 focus:bg-gray-700 focus:outline-none flex-none"
              }, null, 512), [
                [_vModelText, _ctx.person.contact.address.zip]
              ]),
              _withDirectives(_createElementVNode("input", {
                placeholder: "Stadt",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.person.contact.address.city) = $event)),
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none flex-grow"
              }, null, 512), [
                [_vModelText, _ctx.person.contact.address.city]
              ])
            ]),
            _withDirectives(_createElementVNode("input", {
              placeholder: "E-Mail",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.person.contact.email) = $event)),
              type: "email",
              class: "bg-gray-800 focus:bg-gray-700 focus:outline-none w-full"
            }, null, 512), [
              [_vModelText, _ctx.person.contact.email]
            ]),
            _withDirectives(_createElementVNode("input", {
              placeholder: "Mobiltelefon",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.person.contact.mobilePhone) = $event)),
              type: "tel",
              class: "bg-gray-800 focus:bg-gray-700 focus:outline-none w-full"
            }, null, 512), [
              [_vModelText, _ctx.person.contact.mobilePhone]
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _hoisted_11,
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.person.contact.messengerPreferences.sms.present) = $event)),
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 512), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.sms.present]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.person.contact.messengerPreferences.sms.preferred) = $event)),
                disabled: !_ctx.person.contact.messengerPreferences.sms.present,
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 8, _hoisted_13), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.sms.preferred]
              ]),
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.person.contact.messengerPreferences.whatsapp.present) = $event)),
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 512), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.whatsapp.present]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.person.contact.messengerPreferences.whatsapp.preferred) = $event)),
                disabled: !_ctx.person.contact.messengerPreferences.whatsapp.present,
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 8, _hoisted_15), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.whatsapp.preferred]
              ]),
              _hoisted_16,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.person.contact.messengerPreferences.signal.present) = $event)),
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 512), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.signal.present]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.person.contact.messengerPreferences.signal.preferred) = $event)),
                disabled: !_ctx.person.contact.messengerPreferences.signal.present,
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 8, _hoisted_17), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.signal.preferred]
              ]),
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.person.contact.messengerPreferences.threema.present) = $event)),
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 512), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.threema.present]
              ]),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.person.contact.messengerPreferences.threema.preferred) = $event)),
                disabled: !_ctx.person.contact.messengerPreferences.threema.present,
                type: "checkbox",
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none justify-self-center"
              }, null, 8, _hoisted_19), [
                [_vModelCheckbox, _ctx.person.contact.messengerPreferences.threema.preferred]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _withDirectives(_createElementVNode("select", {
                id: "basicDiet",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.person.foodRestrictions.basicDiet) = $event)),
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none flex-grow"
              }, _hoisted_26, 512), [
                [_vModelSelect, _ctx.person.foodRestrictions.basicDiet]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("select", {
                id: "restrictions",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.person.foodRestrictions.religiousRestrictions) = $event)),
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none flex-grow"
              }, _hoisted_32, 512), [
                [_vModelSelect, _ctx.person.foodRestrictions.religiousRestrictions]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "Allergien (z.B. Erdnuss)",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.person.foodRestrictions.allergies) = $event)),
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none flex-grow"
              }, null, 512), [
                [_vModelText, _ctx.person.foodRestrictions.allergies]
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "Intoleranzen (z.B. Zwiebeln)",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.person.foodRestrictions.intolerances) = $event)),
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none flex-grow"
              }, null, 512), [
                [_vModelText, _ctx.person.foodRestrictions.intolerances]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                id: "accomodation",
                type: "checkbox",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.person.requestAccommodationsInfo) = $event)),
                class: "bg-gray-800 focus:bg-gray-700 focus:outline-none flex-none mt-2 mr-2"
              }, null, 512), [
                [_vModelCheckbox, _ctx.person.requestAccommodationsInfo]
              ]),
              _hoisted_36
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["text-center w-full mt-5", 
            _ctx.entryComplete(_ctx.person)
              ? 'bg-blue-900 hover:bg-blue-800 text-white'
              : 'bg-gray-900'
          ]),
              title: _ctx.entryComplete(_ctx.person)
              ? '' : 'Es fehlen noch Daten.',
              confirmButton: !_ctx.entryComplete(_ctx.person),
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.checkConfirmation()))
            }, " Bestätigen ", 10, _hoisted_37)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.confirmationVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
          _hoisted_39,
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("button", {
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.confirmData())),
              class: "text-center w-24 mt-5 bg-blue-900 hover:bg-blue-800 text-white"
            }, " Bestätigen "),
            _createElementVNode("button", {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.notConfirmed())),
              class: "text-center w-24 mt-5 bg-blue-900 hover:bg-blue-800 text-white"
            }, " Zurück ")
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_41,
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_l_map, {
          key: 2,
          class: "h-full w-full z-0 top-0 fixed",
          center: _ctx.center,
          minZoom: 17,
          maxZoom: 17,
          options: { zoomControl: false }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_l_geo_json, {
              geojson: _ctx.geojson,
              options: _ctx.geojsonOptions
            }, null, 8, ["geojson", "options"]),
            _createVNode(_component_l_tile_layer, {
              class: "z-0",
              url: "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png?api_key=214a06d2-3e81-41e1-8382-6fbbd1689bfc"
            })
          ]),
          _: 1
        }, 8, ["center"]))
      : _createCommentVNode("", true)
  ]))
}